// extracted by mini-css-extract-plugin
module.exports = {"root":"Node_root__2QYPV","row":"Node_row__3Mms0","label":"Node_label__2026S","footer":"Node_footer__1tG42"};